import { useState } from "react";
import usePersistedState from "../../lib/usePersistedState";
import { trackEvent } from "../../lib/analytics";
import { looksLikeStoreAddress } from "../RequestForm";

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content;
}

/* The pizzeria intake form: same create/handoff mechanics as AovAuditForm
   (URL in, audit_path out), restyled for the bundle menu door and tracked
   under its own form name so the campaign reads separately in analytics. */
export default function PizzaMenuForm({ createPath }) {
  const [domain, setDomain] = usePersistedState("audit.domain");
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const submit = async (event) => {
    event.preventDefault();
    if (!looksLikeStoreAddress(domain)) {
      setErrors({ domain: ["Enter your .myshopify.com domain or your store's web address (like https://yourstore.com)."] });
      return;
    }
    setSubmitting(true);
    setErrors({});

    try {
      const response = await fetch(createPath, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": csrfToken() },
        body: JSON.stringify({ domain }),
      });
      const data = await response.json();

      if (response.ok) {
        trackEvent("aov_audit_started", { form: "bundle_menu" });
        window.location.href = data.audit_path;
      } else {
        setErrors(data.errors || { base: ["Something went wrong. Please try again."] });
        setSubmitting(false);
      }
    } catch {
      setErrors({ base: ["We couldn't reach the server. Please try again."] });
      setSubmitting(false);
    }
  };

  const fieldErrors = (key) => (errors[key] || []).join(", ");
  const errorText = fieldErrors("domain") || fieldErrors("myshopify_domain") || fieldErrors("base");

  return (
    <form onSubmit={submit} noValidate>
      <div className="intake-form">
        <input
          type="text"
          required
          placeholder="https://yourstore.com"
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
          autoComplete="off"
          spellCheck="false"
          aria-label="Your Shopify store URL or myshopify domain"
        />
        <button className="btn tomato" type="submit" disabled={submitting}>
          {submitting ? "Firing up the oven…" : "Get my readiness score →"}
        </button>
      </div>
      {errorText && <p className="form-error">{errorText}</p>}
    </form>
  );
}
